//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import Multiselect from 'vue-multiselect'

import {BCalendar, BTime, BFormGroup, BFormInput, BFormDatepicker, BFormTimepicker, BIconXCircleFill, BButton } from 'bootstrap-vue'

import {validationMixin} from "vuelidate"
import {required, minLength} from "vuelidate/lib/validators"

export default {

    name: 'CreateMeetingDate',

    mixins: [validationMixin],

    components: {BCalendar, BTime, BFormGroup, BFormInput, BFormDatepicker, BFormTimepicker, BIconXCircleFill, BButton, Multiselect},

    props: {
        company: {},
        timezones: {},
        dateData: {
            type: Object,
            default: {
                duration: '',
                timezone: '',
                dates: [
                    { date: '', time: ''}
                ],
            }
        },
    },

    data() {
        return {
            selectedTimezone: this.dateData.timezone,
            selectedDuration: this.dateData.duration,
            min: new Date(),
            durations: [
                {
                    text: '30 min',
                    value: 30
                },
                {
                    text: '1 hour',
                    value: 60
                },
                {
                    text: '1.5 hours',
                    value: 90
                },
                {
                    text: '2 hours',
                    value: 120
                },
            ],

            selectedDates: [
                { date: '', time: ''}
            ],
        }
    },

    validations: {
        selectedDuration: {
            required,
        },
        selectedTimezone: {
            required,
        },
        selectedDates: {
            required,
            minLength: minLength(1),
            $each: {
                date: {
                    required,
                },
                time: {
                    required,
                },
            }
        }
    },

    mounted() {

        if(this.dateData.dates) {
            this.selectedDates = this.dateData.dates
        }

        this.selectedTimezone = this.$helper.localTimezone(this.$logger)

    },

    methods: {

        fieldInvalid(field) {
              if(field.$dirty === false) {
                  return false
              }

            return field.$error
        },

        getState(field) {

            if(field.$dirty === false) {
                return null
            }

            return !field.$error
        },

        addDateRow() {
            this.selectedDates.push({ date: '', time: ''})
        },

        removeDateRow(index) {
            this.selectedDates.splice(index,1)
        },

        selectDuration(value) {
            this.selectedDuration = value
            this.$v.selectedDuration.$touch()
        },

        onNext() {

            this.$v.$touch()

            if (this.$v.$invalid) {
                this.$toast.global.my_error({message: 'Please fill all required fields'})
                return false;
            } else {

                const data = {
                    duration: this.selectedDuration,
                    timezone: this.selectedTimezone,
                    dates: this.selectedDates,
                }

                this.$emit('next', data)

            }

        },

    },

    computed: {

        selectedDatesCount() {
            if(!this.selectedDates) {
                return 0
            }
            return this.selectedDates.length
        }

    },

}
